import React from 'react';
import { Callout, DocHeading, ReqRow } from './components';

function PageRequirements() {
  return (
    <div>
      <h1 className="text-[2.5rem] leading-[1.1] font-semibold text-white tracking-[-0.02em] mb-3">System Requirements</h1>
      <p className="text-gray-400 leading-relaxed mb-8">
        Make sure your system meets the following requirements before installing MortisEngine.
      </p>

      <DocHeading>Minimum Requirements</DocHeading>
      <div className="card overflow-hidden mb-6">
        <ReqRow label="Operating System" value="Windows 10 64-bit" />
        <ReqRow label="GPU"              value="DirectX 11 capable" />
        <ReqRow label="RAM"              value="4 GB" />
        <ReqRow label="Storage"          value="~50 MB free space" />
        <ReqRow label="Internet"         value="Active connection (license check)" />
        <ReqRow label="Game client"      value="Drakensang Online (any version)" />
      </div>

      <Callout type="warning">
        Windows 7, 8, and 32-bit operating systems are <strong>not supported</strong>.
        The loader requires a 64-bit Windows 10 or newer.
      </Callout>

      <DocHeading>No Additional Runtimes Needed</DocHeading>
      <p className="text-sm text-gray-400 mb-4">
        The loader is a native Windows executable with no external runtime dependencies.
        No .NET, no Visual C++ redistributable, no additional installs — just extract and run.
        DirectX 11 is built into Windows 10 and newer.
      </p>
      <Callout type="info">
        On systems where hardware DirectX 11 acceleration fails, the loader automatically
        falls back to WARP (software rendering) so it still works.
      </Callout>
    </div>
  );
}

export default PageRequirements;
